export default function buildPostSalePoints({
    apiEndpoint,
    apiTools
}) {
    return async function postSalePoints(args) {
        const url = apiTools.resolveUrl({
            ...args,
            apiEndpoint: `${ apiEndpoint }`
        })

        const res = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json'
            },
            credentials: 'include',
            body: args.body
        });
        return await res.json();
    }
}